{
  "analysis": {
    "analysis_help_title": "Cómo usar las herramientas",
    "analysis_help_description": "Utilice las herramientas de dibujo para dibujar una línea o un área en el mapa. Con un objeto seleccionado, expanda las secciones siguientes para mostrar los distintos tipos de análisis."
  },
  "sidebarToolbar": {
    "delete_layer": "Eliminar capa",
    "remove_layer": "Eliminar capa"
  },
  "sidebarLayers": {
    "emptyLayer": "{{ layerName }} aún no tiene objetos",
    "emptyGroup": "{{ groupName }} no tiene capas ni grupos"
  },
  "attributes": {
    "namingOrder": "Orden de nomenclatura",
    "customerIdentifier": "Nombre identificador del cliente",
    "list_items": {
      "add_another_placeholder": "Agregar otra opción de lista",
      "add_first_placeholder": "Agregar una opción de lista"
    },
    "dataDriven": {
      "canDo": "Estilo basado en atributos",
      "noDatafields": "Añade atributos para usar un estilo basado en atributos",
      "label": "Establézcalo mediante atributos",
      "tour": {
        "stage_one": {
          "title": "Estilo basado en atributos",
          "content": "Debe añadir un atributo a la lista antes de poder aplicar estilos a su capa por valores de atributo"
        }
      }
    },
    "predefined_subtitle": "Elija entre un conjunto de atributos listos para usar",
    "custom_subtitle": "Crea tu propio atributo, como una lista personalizada o un cuadro de entrada de texto",
    "attribute_type": "Tipo de atributo",
    "create_new_attribute": "Cree un nuevo atributo eligiendo un tipo de la lista siguiente y edítelo según sus necesidades",
    "edit_attribute": "Edita este atributo eligiendo un tipo de la siguiente lista y edítalo según tus necesidades",
    "edit_attribute_no_type": "Edite este atributo mediante los campos siguientes y edítelo según sus necesidades",
    "create_attribute_title": "Crea un atributo",
    "edit_attribute_title": "Editar atributo",
    "add_attribute_subtitle": "Añada un nuevo atributo eligiendo uno predefinido o creando uno nuevo desde cero",
    "predefined_info_title": "Atributos predefinidos",
    "predefined_info_text": "Los administradores del proyecto pueden gestionarlos en la configuración del proyecto",
    "predefined_info_link": "Haga clic aquí para ir a la «Configuración del proyecto»",
    "create_predefined_title": "Crea un atributo predefinido"
  },
  "styles": {
    "fill": "Rellenar"
  },
  "layer_tour": {
    "tip_1_welcome": {
      "title": "Personaliza tu capa",
      "content": "Puede cambiar el aspecto de la capa y la información (atributos) que desea almacenar cuando añada objetos al plan."
    },
    "tip_2_name": {
      "title": "Nombre de la capa",
      "content": "Cambie el nombre de la capa para ayudar a describir lo que va a agregar al plan"
    },
    "tip_3_attributes": {
      "title": "Atributos",
      "content": "Agregue atributos (opcional) para almacenar información sobre los objetos del plan. Por ejemplo, puede capturar los tipos y categorías, los costos, las cantidades, las fechas o cualquier otra cosa que necesite."
    },
    "tip_4_styles": {
      "title": "Estilos",
      "content": "Cambia el aspecto que tendrán los objetos de esta capa en el plano, como los colores y los tamaños."
    },
    "tip_5_attribute_styles": {
      "title": "Estilo basado en atributos",
      "content": "Usa los atributos para determinar el aspecto de los objetos. Por ejemplo, diferentes «tipos o categorías» pueden tener colores diferentes."
    },
    "tip_6_save": {
      "title": "Guardar",
      "content": "Cuando haya terminado, pulse guardar para añadir la capa al plan. Siempre puedes cambiar estos ajustes más adelante, como añadir más atributos o ajustar el estilo."
    }
  },
  "formula_summary": {
    "remove_formula": "Eliminar la fórmula"
  },
  "layer_information": {
    "title": "Información de capa",
    "owner_map_location": "Ubicación del plan del propietario",
    "open_in_folder": "Abrir en carpeta",
    "created_by": "Creado por",
    "created_on": "Creado el",
    "last_modified": "Modificado por última vez",
    "permissions": "Permisos",
    "view_collaborators": "Ver y editar colaboradores",
    "visualiser_overflow": "... {{ nodeCount }} más carpetas",
    "edit_style": "Ajustes de capa"
  },
  "edit_layer": {
    "add_to_map": "Añadir al plan",
    "customise": "Personaliza la plantilla",
    "text_position": "Posición del texto",
    "text_offset": "Desfase de texto"
  },
  "style_errors": {
    "invalid_incrementor_value": "Valor no válido. Introduce un valor entre {{ minValue }} y {{ maxValue }}"
  },
  "style": {
    "error": "Algo salió mal, los cambios de capa no se guardaron"
  },
  "toolbarButtonTooltips": {
    "confirm_action": "Dibujo completo"
  }
}